import React from 'react'
import Header from '../components/header/Header'
import UserOsBig from '../assets/UserOs-big.jpg'
import Footer from '../components/footer/Footer'
import Contact from '../components/contact/Contact'
import Description from '../components/description/description'
import { BiCheck } from 'react-icons/bi'
import TitleText from '../utils/TitleText'
import HomeButton from '../components/homebutton/HomeButton'
const UserOs = () => {
    const footitems=[
        {sec:'#',title:'Home'},
        {sec:'#description',title:'Description'},
        {sec:'#contact',title:'Contact'},

    ]
    TitleText('User Operating System')
  return (
    <>
        <HomeButton/>
        <Header text1="" text2="User Operating System" text3="" img={UserOsBig} />
        <Description title= 'Desciption' link ='https://github.com/Anmol23oct/User-Operating-System-Core' data={
            <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Implemented two main types of scheduler in an operating system, MLFQ and Round Robin.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Developed new design of TLB cache to optimize the workflow of page directory as well as tables. </p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Enhanced the new architectural flow of metadata in different page level handling using Inode optimization.</p>
            </li>
    
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Tech Stack: C , Linux, Unix</p>
            </li>
    
          </ul>
        }/>
        <Contact/>
        <Footer footitems={footitems}/>
    </>
  )
}

export default UserOs